import { useStore } from 'react-admin';
export var useExpandedKeys = function (key, defaultValue) {
    if (key === void 0) { key = 'ra-tree.expandedKeys'; }
    if (defaultValue === void 0) { defaultValue = undefined; }
    return useStore(key, defaultValue);
};
